import axios from "../../../services/axios-config.js";

export function getAdminActionsLog({ page, limit, action, adminName, companyName, startDate, endDate }) {
    return new Promise(async (resolve, reject) => {
        try {
            const params = new URLSearchParams();
            if (action && action !== 'ALL') params.append('action', action);
            if (adminName) params.append('adminName', adminName);
            if (companyName) params.append('companyName', companyName);
            if (startDate) params.append('startDate', startDate);
            if (endDate) params.append('endDate', endDate);

            const queryString = params.toString() ? `?${params.toString()}` : '';
            const res = await axios.get(`/admin/actions-log/${page}/${limit}${queryString}`);

            if (res.status === 200) return resolve(res.data);

        } catch (e) {
            console.error('ERROR - GET ADMIN ACTIONS LOG FUNCTION:', e);
            reject(e);
        }
    });
}
